import { render, staticRenderFns } from "./MarketPriceList.vue?vue&type=template&id=68f7cff0&scoped=true&"
import script from "./MarketPriceList.vue?vue&type=script&lang=js&"
export * from "./MarketPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f7cff0",
  null
  
)

export default component.exports